module.exports = __webpack_public_path__ + "c7b975f3e8445b8b780e6e2ddc8fdaaa.woff2";